import { useContext, useState } from "react";

import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBin4Line } from "react-icons/ri";
import { CgUnavailable } from "react-icons/cg";
import { AiOutlineCheckCircle } from "react-icons/ai";
import { toast } from "react-hot-toast";
import useAxios from "../../services/useAxios.tsx";

import ManagementContext from "../../context/WebInfo/ManagementContext.jsx";
import { showSwalQuestion } from "../../utils/swal";
import ProductContext from "context/ProductContext/ProductDataContext.jsx";

export default function AdminOperation({
  id,
  status,
  productData,
  left = "-10",
  top = "20",
  slug,
}) {
  const { setControllerProduct } = useContext(ManagementContext);
  const { setProductListUpdater } = useContext(ProductContext);
  const { execute: updateProductApi } = useAxios("api/Update_products");

  function updateProduct(status, id) {
    //status : 0 active, -1 deactive, -2 delete
    let txt = "";
    if (status == 0) txt = "فعال";
    else if (status == -1) txt = "غیرفعال";
    else if (status == -2) txt = "حذف";

    showSwalQuestion(
      `آیا از ${txt} کردن محصول اطمینان دارید؟`,
      "تایید",
      "انصراف"
    ).then((result) => {
      if (result.isConfirmed) {
        let formdata = new FormData();
        formdata.append("conditions", `id/=/${id}`);
        formdata.append("keyvalues", `status,${status}`);

        updateProductApi(formdata).then((data) => {
          if (data.status == 1) {
            toast.success(` محصول با موفقیت ${txt} شد.`);

            setProductListUpdater((prev) => !prev);
          } else
            toast.error(
              `متاسفانه مشکلی در فرایند پیش آمده است، لطفا مجدد تلاش کنید.`
            );
        });
      }
    });
  }

  return (
    <div
      className="position-absolute "
      style={{
        backgroundColor: "tomato",
        left: `${left}px`,
        borderRadius: "0 10px 10px 0",
        width: 30,
        top: `${top}px`,
        zIndex: "1",
      }}
    >
      <div className="text-center py-3 px-1 pointer">
        <FaRegEdit
          onClick={() =>
            setControllerProduct({
              show: true,
              type: "edit",
              details: { ...productData, id: id },
            })
          }
          style={{ width: 17, height: 17 }}
          color="white"
          data-tooltip-id="my-tooltip"
          data-tooltip-content="ویرایش"
        />
      </div>
      <div
        className="text-center py-3 px-1 pointer"
        onClick={() => updateProduct(-2, id)}
      >
        <RiDeleteBin4Line
          style={{ width: 18, height: 18 }}
          color="white"
          data-tooltip-id="my-tooltip"
          data-tooltip-content="حذف"
        />
      </div>
      {status == 0 && (
        <div
          className="text-center py-3 px-1 pointer"
          onClick={() => updateProduct(-1, id)}
        >
          <CgUnavailable
            style={{ width: 18, height: 18 }}
            color="white"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="غیرفعال"
          />
        </div>
      )}
      {status == -1 && (
        <div
          className="text-center py-3 px-1 pointer"
          onClick={() => updateProduct(0, id)}
        >
          <AiOutlineCheckCircle
            style={{ width: 18, height: 18 }}
            color="white"
            data-tooltip-id="my-tooltip"
            data-tooltip-content="فعال"
          />
        </div>
      )}
    </div>
  );
}
